const openInNewTab = url => {
  if (url.startsWith('www')) url = 'http://' + url
  const w = window.open(url, '_blank', 'noopener,noreferrer')
  if (w) w.opener = null
}

export default openInNewTab
